import { useExternalSignEgovLink } from "@/modules/gateway/features/open-external-sign/model/use-nca-layer-sign-external-registration";
import { SignRegistrationForExternalSignPageFragment } from "gql/graphql";
import { BaseSignWithNCALayerButton } from "@/modules/signing/features/sign-with-ncalayer/ui/base-sign-button";

export function SignCALayerButton({
  registrationCode,
  signRegistration,
  afterSign,
}: {
  registrationCode: string;
  signRegistration: SignRegistrationForExternalSignPageFragment;
  afterSign?: () => void;
}) {
  const docs =
    signRegistration?.documents.map((doc) => doc.file.base64Content) ?? [];

  const { sign: signRegistrations, loading: signLoading } =
    useExternalSignEgovLink({ afterSubmit: afterSign });

  return (
    <BaseSignWithNCALayerButton
      docs={docs}
      loading={signLoading}
      onSign={async (signatures) => {
        await signRegistrations({
          signatures: signatures,
          code: registrationCode,
        });
      }}
    />
  );
}
